/** @format */

import React, { FC } from 'react'
import { _$ } from '@king-design/react'
import styled from 'styled-components'
import MonitorCrumb from 'src/components/MonitorCrumb'
import AlarmTactics from 'src/containers/MonitorAlarmTemplate'
interface Props {
  className?: string
}

const MonitorAlarmTactics: FC<Props> = ({ className }) => {
  return (
    <div className={className}>
      <MonitorCrumb breadArr={[{ title: _$('告警服务') }, { title: _$('触发条件模版') }]} />
      <AlarmTactics />
    </div>
  )
}

export default styled(MonitorAlarmTactics)``
